import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import { colorToken, useStyleProps } from '../utils';
/**
 * Компонент `<Typography />` используется для отображения текстовой информации.
 * @param {TypographyProps} props
 * @constructor
 */

export const Typography = /*#__PURE__*/forwardRef(function Typography({
  children,
  variant,
  size,
  className,
  as = 'span',
  color,
  style,
  ...props
}, ref) {
  const styleProps = useStyleProps({
    color
  }, typographyStyleProps, style);
  const classNames = useMemo(() => {
    const actualVariant = variant === 's' || variant === 'm' || variant === 'l' ? `_${variant}` : variant;
    return clsx(styles.typography, styles[actualVariant], size && styles[size], className);
  }, [className, variant, size]);
  return /*#__PURE__*/React.createElement(as, { ...props,
    ...styleProps,
    className: classNames,
    ref
  }, children);
});
const typographyStyleProps = {
  color: ['color', colorToken]
};